import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import '../../styles/colors.scss';
import './typography.scss';

export default function Text({
  component: Component = 'p',
  secondary,
  caption1,
  caption2,
  radioLabel,
  bold,
  children,
  className,
  color,
  id,
  inline,
  size,
  fontWeight
}) {
  const classnames = cx(className, {
    'Text': true,
    'Text--h1': Component === 'h1',
    'Text--h2': Component === 'h2',
    'Text--h3': Component === 'h3',
    'Text--h4': Component === 'h4',
    'Text--h5': Component === 'h5',
    'Text--p': Component === 'p',
    'Text--span': Component === 'span',
    'Text--linkDefault': Component === 'a',
    'Text--secondary': secondary, //If paragraph is Secondary Text
    'Text--caption1': caption1,
    'Text--caption2': caption2,
    'Text--radioLabel': radioLabel,
    [color]: color,
    'Text--bold': bold,
    'Text--inline': inline,
    [`Text--${size}`]: size,
    [`Text--fontWeight-${fontWeight}`]: fontWeight
  });

  return <Component className={classnames} id={id}>{children}</Component>;
}

const grays = [
  'gray',
  'darkGray',
  'darkerGray',
  'darkestGray',
  'transparentGray',
  'lightGray',
  'lighterGray',
  'lightestGray',
  'shadowGray'
];
const alternateSpellingGreys = [
  'grey',
  'darkGrey',
  'darkerGrey',
  'darkestGrey',
  'transparentGrey',
  'lightGrey',
  'lighterGrey',
  'lightestGrey',
  'shadowGrey'
];

Text.propTypes = {
  component: PropTypes.oneOf([
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'span',
    'div',
    'a'
  ]),
  secondary: function(props, propName, componentName) {
    const isPOrSpan = props.component === 'p' || props.component === 'span' || !props.component;
    if ((!isPOrSpan && props.secondary) || (isPOrSpan && props.secondary && (props.caption1 || props.caption2))) {
      return new Error(
        'Invalid prop `' + propName + '` supplied to' +
        ' `' + componentName + '`. Validation failed.'
      );
    }
  },
  caption1: function(props, propName, componentName) {
    const isPOrSpan = props.component === 'p' || props.component === 'span' || !props.component;
    if ((!isPOrSpan && props.caption1) || (isPOrSpan && props.caption1 && (props.secondary || props.caption2))) {
      return new Error(
        'Invalid prop `' + propName + '` supplied to' +
        ' `' + componentName + '`. Validation failed.'
      );
    }
  },
  caption2: function(props, propName, componentName) {
    const isPOrSpan = props.component === 'p' || props.component === 'span' || !props.component;
    if ((!isPOrSpan && props.caption2) || (isPOrSpan && props.caption2 && (props.caption1 || props.secondary))) {
      return new Error(
        'Invalid prop `' + propName + '` supplied to' +
        ' `' + componentName + '`. Validation failed.'
      );
    }
  },
  bold: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object
  ]),
  color: PropTypes.oneOf([
    'accent',
    'blue',
    'black',
    'darkBlue',
    'darkPink',
    'darkPurple',
    'darkSteel',
    'error',
    'focus',
    ...grays,
    ...alternateSpellingGreys,
    'info',
    'indigo',
    'link',
    'pink',
    'purple',
    'steel',
    'success',
    'transparentWhite',
    'transparent',
    'transparentOverlay',
    'white',
    'aqua'
  ]),
  id: PropTypes.string,
  inline: PropTypes.bool,
  size: PropTypes.oneOf([
    'verylarge',
    'large',
    'largeButton',
    'largeFilter',
    'medium',
    'small',
    'smallFilter',
    'verySmall'
  ]),
  fontWeight: PropTypes.oneOf([
    '100',
    '200',
    '300',
    '400',
    '500',
    '600',
    '700',
    '800',
    '900'
  ])
};
